// extracted by mini-css-extract-plugin
module.exports = {"control":"Checkbox__control--2vA","content":"Checkbox__content--3RR","hint":"Checkbox__hint---SG","controlMultiselect":"Checkbox__controlMultiselect--Dwk"};